import React from "react";
var __jsx = React.createElement;
import { Fragment, useEffect } from "react";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { useTranslation } from "@i18n";
import Layout from "@/_LayoutsRelated/layout/Layout";
import stl from "./LandingPageRoot.module.css";
import SellTradeHero from "@/pages/landingPages/components/sellTradeHero/SellTradeHero";
import CardsSlider from "@/pages/landingPages/components/cardsSlider/CardsSlider";
import { useCMS } from "@hooks/useCMS";
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
import useHelpers from "@hooks/useHelpers";
import { PageNamesEnum } from "@/routes/routes";
import BrowseCarsBy from "@/pages/landingPages/components/sections__BrowseCarsBy/BrowseCarsBy";
import BulletedList from "@/pages/landingPages/components/shared__BulletedList/BulletedList";
import BanksGroup from "@/pages/landingPages/components/section__BanksGroup/BanksGroup";
import InstallmentCalculatorSection from "@/sections/finance-calculator-landing/views/InstallmentCalculatorSection";
import { BulletedListCards } from "@/pages/landingPages/components/shared__BulletedListCards";
import { LandingPageComponentType } from "@type/models/cms-landing";
import BreadCrumb from "@componentsShared/BreadCrumb";
import Spacing from "@/_LayoutsRelated/spacing/Spacing";
import EligibilityComponent from "@/_MiniApps/EligibilityComponent/EligibilityComponent";
import useIsMobile from "@hooks/useIsMobile";
var LandingPageRoot = function LandingPageRoot() {
  var webview = useWebView();
  var isWebView = useIsWebView();
  var _useCMS = useCMS(),
    urlHelper = _useCMS.urlHelper;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var pageData = useFullPageData(PageNamesEnum.PAGE_NAME__LandingPageRoot);
  if (!pageData) return null;
  var pageContent = getPageContent(pageData);
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var backClicked = function backClicked() {
    webview.closeScreen()["catch"](function () {
      document.location.href = createUrl("/");
    });
  };
  useEffect(function () {
    webview.showTitleBar(false)["catch"](function () {
      if (isWebView) {
        /** @FIXME TEMP Solution to hide Header for webview on old version ticket [SE-5723] **/
        document.body.classList.add("FIX_ME_OLD_ANDROID_IN_APP_WEBVIEW");
      }
    });
    return function () {
      if (isWebView) {
        /** @FIXME TEMP Solution to hide Header for webview on old version ticket [SE-5723] **/
        document.body.classList.remove("FIX_ME_OLD_ANDROID_IN_APP_WEBVIEW");
      }
    };
  }, [isWebView]);
  var mobileHeader = function mobileHeader() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: stl.landingMobileHeading
    }, /*#__PURE__*/React.createElement("span", {
      onClick: backClicked
    }), /*#__PURE__*/React.createElement("strong", null, t("sell_car", {
      ns: "web_common"
    }))));
  };
  var mobileStickyButton = function mobileStickyButton() {
    var _pageData$mobile_stic, _pageData$mobile_stic2, _pageData$mobile_stic3;
    if (!(pageData !== null && pageData !== void 0 && (_pageData$mobile_stic = pageData.mobile_sticky_cta) !== null && _pageData$mobile_stic !== void 0 && _pageData$mobile_stic.text)) return null;
    return /*#__PURE__*/React.createElement("a", {
      id: "mobileStickyButton",
      href: urlHelper(pageData === null || pageData === void 0 ? void 0 : (_pageData$mobile_stic2 = pageData.mobile_sticky_cta) === null || _pageData$mobile_stic2 === void 0 ? void 0 : _pageData$mobile_stic2.url),
      className: ["blueBtn", stl.landBtn].join(" ")
    }, pageData === null || pageData === void 0 ? void 0 : (_pageData$mobile_stic3 = pageData.mobile_sticky_cta) === null || _pageData$mobile_stic3 === void 0 ? void 0 : _pageData$mobile_stic3.text);
  };
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    hasNavBar: true,
    authenticationMsg: true,
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true
    //hasMobFooter
    ,
    loading: true,
    mainClass: stl.mainFinancingClass,
    hideHeaderOnmobile: pageData.slug !== 'financing/calculator',
    custommobileHeader: pageData.slug !== 'financing/calculator' && mobileHeader(),
    customStikeyButton: mobileStickyButton(),
    showUserAvatar: true
  }, pageContent, /*#__PURE__*/React.createElement("div", {
    className: [stl.stikeyWebApp, "showWebView", "webviewLoaded"].join(" ")
  }, mobileStickyButton()));
};
export default LandingPageRoot;
function getPageContent(pageData) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, pageData === null || pageData === void 0 ? void 0 : pageData.contentSections.map(function (section, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, renderHeadlessCmsComponent(section, pageData));
  }));
}
var BreadcrumbGeneric = function BreadcrumbGeneric(_ref) {
  var breadcrumb = _ref.breadcrumb;
  var _useHelpers2 = useHelpers(),
    createUrl = _useHelpers2.createUrl;
  var extraLinks = [];
  if (breadcrumb.label1) {
    extraLinks.push({
      link: createUrl(breadcrumb.link1),
      title: breadcrumb.label1
    });
  }
  if (breadcrumb.label2) {
    extraLinks.push({
      link: createUrl(breadcrumb.link2),
      title: breadcrumb.label2
    });
  }
  if (breadcrumb.label3) {
    extraLinks.push({
      link: createUrl(breadcrumb.link3),
      title: breadcrumb.label3
    });
  }
  if (breadcrumb.label4) {
    extraLinks.push({
      link: createUrl(breadcrumb.link4),
      title: breadcrumb.label4
    });
  }
  return /*#__PURE__*/React.createElement(BreadCrumb, {
    hasSchemaOrg: true,
    links: [].concat(extraLinks)
  });
};
function renderHeadlessCmsComponent(section, pageData) {
  var _pageData$payload, _financingCalculatorD;
  var isMobile = useIsMobile();
  switch (section.__component) {
    case LandingPageComponentType.LAYOUT_BREADCRUMB:
      return /*#__PURE__*/React.createElement("div", {
        className: "max-width mx-auto mt-8 md:mt-10"
      }, /*#__PURE__*/React.createElement(BreadcrumbGeneric, {
        breadcrumb: section
      }));
    case LandingPageComponentType.SELL_TRADE_HERO:
      return /*#__PURE__*/React.createElement(SellTradeHero, section);
    case LandingPageComponentType.CARDS_SLIDER:
      return /*#__PURE__*/React.createElement(CardsSlider, section);
    case LandingPageComponentType.BROWSE_CARS_BY:
      var browseCarsByData = section;
      return /*#__PURE__*/React.createElement("div", {
        className: stl.BrowseCarsBy_container
      }, /*#__PURE__*/React.createElement(BrowseCarsBy, {
        products: (_pageData$payload = pageData.payload) === null || _pageData$payload === void 0 ? void 0 : _pageData$payload.carsSearchResults.products,
        title: browseCarsByData.title,
        headingType: browseCarsByData.heading || "h3",
        number_of_cars: browseCarsByData.number_of_cars,
        cta: browseCarsByData.cta
      }));
    case LandingPageComponentType.FINANCING_CALCULATOR:
      var financingCalculatorData = section;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InstallmentCalculatorSection, {
        initialCashPrice: ((_financingCalculatorD = financingCalculatorData.initial_price) === null || _financingCalculatorD === void 0 ? void 0 : _financingCalculatorD.toString()) || "0"
      }), /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement(EligibilityComponent, {
        design: !isMobile ? "banner" : "card",
        entryPoint: "seo_calculator_page",
        skipFlag: true
      })));
    case LandingPageComponentType.BULLETED_LIST:
      var bulletedListData = section;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BulletedList, {
        list: bulletedListData
      }));
    case LandingPageComponentType.BANKS_GROUP:
      var banksGroupData = section;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BanksGroup, banksGroupData));
    case LandingPageComponentType.BULLETED_LIST_CARDS:
      var bulletedListCardsData = section;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BulletedListCards, {
        data: bulletedListCardsData
      }));
  }
}